import type { TAgriculturalProductFilterName } from '@/types/Catalog'
import { AGRICULTURAL_PRODUCT_FILTER_NAMES } from '../constants'

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAgriculturalProductFilterName(key: any): key is TAgriculturalProductFilterName {
  return AGRICULTURAL_PRODUCT_FILTER_NAMES.includes(key)
}
